import { render, staticRenderFns } from "./Salas.vue?vue&type=template&id=13aad3d9&scoped=true&"
import script from "./Salas.vue?vue&type=script&lang=js&"
export * from "./Salas.vue?vue&type=script&lang=js&"
import style0 from "./Salas.vue?vue&type=style&index=0&id=13aad3d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aad3d9",
  null
  
)

export default component.exports